import { useKestrel } from 'features/kestrelViewer'
import { DeleteVMButton } from 'features/kestrelViewer/ui/tools/DeleteVMButton'
import { ExportControlsSubmenu } from 'features/kestrelViewer/ui/tools/exportControls/ExportControlsSubmenu'
import { InfoButton } from 'features/kestrelViewer/ui/tools/InfoButton'
import { SettingsButton } from 'features/kestrelViewer/ui/tools/SettingsButton'
import React from 'react'

export const MiscTools: React.FC = () => {
  // Wrapper for non-mode and non-toggle tooling
  const { gatekeeper } = useKestrel()
  return (
    <div>
      {gatekeeper.feature.exportControls && <ExportControlsSubmenu />}
      <DeleteVMButton />
      <SettingsButton />
      {gatekeeper.feature.infoModal && <InfoButton />}
    </div>
  )
}
